// Module
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { GlobalModule } from './global/global.module';

import { getAnalytics, provideAnalytics } from '@angular/fire/analytics';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';

// Component
import { BrowserModule } from '@angular/platform-browser';
import { QbBackButtonModule } from '@fwmovilidad/qb-lib-ng-components/deprecated';
import { QbFooterModule, QbHeaderModule } from '@fwmovilidad/qb-lib-ng-components/material';
import { AppComponent } from './app.component';
import { SharedModule } from './shared';

// Angular material
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { environment } from '@environments/environment';
// TranslateModule
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CustomMissingTranslationHandler } from './core/services/language/missing-translation-handler';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        NgbModule,
        AppRoutingModule,
        BrowserModule,
        SharedModule,
        CoreModule,
        IonicModule.forRoot(),
        GlobalModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient],
            },
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: CustomMissingTranslationHandler,
            },
        }),
        BrowserAnimationsModule,
        // Lib
        QbHeaderModule,
        QbBackButtonModule,
        QbFooterModule,
    ],
    providers: [
        provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
        provideAnalytics(() => getAnalytics()),
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent]
})
export class AppModule { }
